import { Product, ProductsListColumnKeys } from '../typings/products';

export const routeToKeyMap = {
    [ProductsListColumnKeys.PRODUCT_NAME]: (item: Product): string => item.productName.toLowerCase(),
    [ProductsListColumnKeys.ID]: (item: Product): string => item.id
};
